import { render, staticRenderFns } from "./submitOrg.vue?vue&type=template&id=ed319f6c&scoped=true&"
import script from "./submitOrg.vue?vue&type=script&lang=js&"
export * from "./submitOrg.vue?vue&type=script&lang=js&"
import style0 from "./submitOrg.vue?vue&type=style&index=0&id=ed319f6c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed319f6c",
  null
  
)

export default component.exports